export default {"src":"/_next/static/media/notification.739629f2.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};